import * as Constants from '../constants/';

export default function(state = {}, action) {
  switch (action.type) {
    case Constants.OPEN_TOAST:
      return {
        ...state,
        isOpen: true,
        [action.toast]: action[action.toast] || true
      };
    case Constants.CLOSE_TOAST:
      return {
        ...state,
        isOpen: false,
        [action.toast]: false
      };
    default:
      return state;
  }
}
